import { useContext } from 'react';

import { INotificationsContext, NotificationsContext } from './NotificationsContext';

// hooks version to be used in functional components
export const useNotifications = (): INotificationsContext => {
	return useContext(NotificationsContext);
};
